import { useSessionStore } from '@/core/auth/sessionStore';
export function setupAuthInterceptor(client) {
    client.interceptors.request.use((config) => {
        const token = useSessionStore.getState().accessToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });
}
